module.exports = __webpack_public_path__ + "static/media/LevelUp.12481f13.svg";